"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationProvider = void 0;
const react_1 = __importDefault(require("react"));
const navigation_context_1 = require("./navigation-context");
const navigation_hook_1 = require("./navigation-hook");
const prompt_dialog_1 = require("./prompt-dialog");
/**
 * Main component for navigation providing context and rendering Prompt if necessary.
 *
 */
function NavigationProvider({ PromptDialogComponent = prompt_dialog_1.PromptDialog, children, }) {
    const { context, dialogRef, prompts, promptConfirm, promptCancel, } = navigation_hook_1.useNavigation();
    return (react_1.default.createElement(navigation_context_1.NavigationContext.Provider, { value: context },
        children,
        react_1.default.createElement(PromptDialogComponent, { ref: dialogRef, prompts: prompts, onConfirm: promptConfirm, onCancel: promptCancel })));
}
exports.NavigationProvider = NavigationProvider;
//# sourceMappingURL=navigation-provider.js.map